/* ==========================================================================
   ACC_EllaOla_LP_05 - Multivitamin Match Quiz
   Ported 1:1 from ellaola-quiz-funnel.html. Questions, points, routing and
   RESULT_COPY are copied verbatim and are NOT customizer settings: the PRD
   locks them to the client logic doc. Products, live prices and page labels
   come from the section's Liquid config (<script data-acc05-config>).

   LOGIC SOURCE: "EllaOola Quiz Funnel - Logic Map & Question Copy" (client doc)
     - Section 3 scoring model  -> QUESTIONS[].options[].points
     - Section 4 routing rules  -> route()
     - Section 5 result copy    -> RESULT_COPY
     - Section 6 question copy  -> QUESTIONS[].q / .options[].label

   Recommendations on the result page are PRE-TICKED (client decision). The
   old "never pre-ticked" note in the source HTML is out of date.
   ========================================================================== */
(function () {
  'use strict';

  /* ==========================================================================
     QUESTIONS  - copy from Section 6, points from Section 3. Do not edit
     without a client sign-off: see PRD "Leave alone".
     ========================================================================== */
  var QUESTIONS = [
    {
      id: 'q1',
      q: 'How old is your child?',
      options: [
        { id: 'toddler', label: 'Toddler', sub: '2 to 3' },
        { id: 'kids', label: 'Kids', sub: '4 to 11' },
        { id: 'teen', label: 'Teen', sub: '12 and up' }
      ]
    },
    {
      id: 'q2',
      q: "What's on your mind for your child right now?",
      help: 'Choose up to 2. These drive the recommendation.',
      multi: 2,
      options: [
        { id: 'vitamin', label: 'Vitamin Deficiency', points: {} },
        { id: 'iron', label: 'Iron Deficiency', points: { I: 3 } },
        { id: 'sick', label: 'Getting sick often', points: { Im: 3, P: 1 } },
        { id: 'mood', label: 'Mood, behavior, or focus', points: { S: 3 } },
        { id: 'sleep', label: 'Sleep', points: { S: 3 } },
        { id: 'digestion', label: 'Digestion or regularity', points: { F: 3, P: 1 } }
      ]
    },
    {
      id: 'q3',
      q: "How would you describe your child's eating habits?",
      options: [
        { id: 'varied', label: 'They eat a wide variety of foods', points: {} },
        { id: 'safe', label: 'They stick to a handful of “safe” foods, but we manage', points: { Pr: 1, F: 1 } },
        { id: 'limited', label: 'Their list of accepted foods is very limited, and mealtimes are genuinely stressful', points: { Pr: 2, F: 1 } }
      ]
    },
    {
      id: 'q4',
      q: "How's your child's digestion these days?",
      options: [
        { id: 'regular', label: 'Regular, no concerns', points: {} },
        { id: 'sometimes', label: 'Irregular sometimes', points: { F: 1 } },
        { id: 'often', label: 'Irregular often, or noticeably uncomfortable', points: { F: 2, P: 2 } }
      ]
    },
    {
      id: 'q5',
      q: 'Does your child tend to be sensitive to things like textures, tags, or loud noises?',
      options: [
        { id: 'no', label: 'Not particularly', points: {} },
        { id: 'some', label: 'Somewhat, it comes up occasionally', points: { S: 1 } },
        { id: 'very', label: 'Very, it affects our daily routines', points: { S: 2 } }
      ]
    }
  ];

  /* ==========================================================================
     RESULT_COPY  - Section 5 of the logic doc, plus condition-matched variants.
     EVERY `why` STRING BELOW THAT IS NOT MARKED "doc" NEEDS CLIENT SIGN-OFF,
     as do the Immunity copy and the handoff lines.
     ========================================================================== */
  var RESULT_COPY = {
    base: {
      headline: 'Your {age} Multivitamin',
      variants: [
        {
          when: function (a) { return answered(a, 'q2', 'vitamin'); },
          why: 'Vitamin gaps are exactly what a daily multivitamin is for. From what you told us, meals and digestion are going well, so this is the safety net for the nutrients that are easy to miss, without changing a single thing about how they already eat.'
        },
        {
          when: function (a) { return answered(a, 'q2', 'iron'); },
          why: "Beyond that, meals and digestion sound like they're going well, so this is a daily safety net for the nutrients that are easy to miss, without changing a single thing about how they already eat."
        }
      ],
      /* doc, Section 5. Unreachable today, kept as the fallback. */
      why: 'Based on what you told us, {name} is getting a solid foundation from food. This gives you a daily safety net for the nutrients that are easy to miss, without changing a single thing about how they already eat.'
    },

    F: {
      variants: [
        /* irregularity + short food list: doc copy, verbatim */
        {
          when: function (a) {
            return (a.q4 === 'sometimes' || a.q4 === 'often') && (a.q3 === 'safe' || a.q3 === 'limited');
          },
          why: "You mentioned some digestive irregularity, and that's incredibly common, especially with a limited diet. Fiber works alongside the multivitamin to support regularity and gut comfort, without adding anything your child will notice."
        },
        {
          when: function (a) { return a.q4 === 'sometimes' || a.q4 === 'often'; },
          why: "You mentioned some digestive irregularity, and that's incredibly common. Fiber works alongside the multivitamin to support regularity and gut comfort, without adding anything your child will notice."
        },
        {
          when: function (a) { return a.q3 === 'safe' || a.q3 === 'limited'; },
          why: 'A short list of accepted foods usually means a short list of fiber sources. Fiber works alongside the multivitamin to support regularity and gut comfort, without adding anything your child will notice.'
        },
        {
          when: function () { return true; },
          why: 'You told us digestion is on your mind. Fiber works alongside the multivitamin to support regularity and gut comfort, without adding anything your child will notice.'
        }
      ],
      rowWhy: 'Supports regularity and gut comfort. Tasteless, so nothing changes at mealtimes.'
    },

    P: {
      variants: [
        /* illness and discomfort both reported: doc copy, verbatim */
        {
          when: function (a) { return answered(a, 'q2', 'sick') && (a.q4 === 'sometimes' || a.q4 === 'often'); },
          why: "Frequent illness and digestive discomfort often trace back to the same place: the gut. Pre+Probiotic adds 15 targeted strains to support immune resilience alongside the multivitamin's foundational nutrients."
        },
        {
          when: function (a) { return answered(a, 'q2', 'sick'); },
          why: "Immune resilience often traces back to the same place: the gut. Pre+Probiotic adds 15 targeted strains to support it alongside the multivitamin's foundational nutrients."
        },
        {
          when: function () { return true; },
          why: "Digestive comfort and regularity both lean on the balance of bacteria in the gut. Pre+Probiotic adds 15 targeted strains and a plant-based prebiotic fibre to support it, alongside the multivitamin's foundational nutrients."
        }
      ],
      rowWhy: '15 targeted strains for immune and digestive support.'
    },

    /* NOT DOC COPY. NEEDS CLIENT SIGN-OFF. */
    Im: {
      why: "You told us they're getting sick more often than you'd like. Immunity pairs a blend of superfruits with the nutrients that support a growing immune system, on top of the multivitamin's daily foundation.",
      rowWhy: 'Superfruits plus key immune-support nutrients. Tasteless, mixes into anything.'
    },

    S: {
      variants: [
        /* both signals present: doc copy, verbatim */
        {
          when: function (a) {
            return (answered(a, 'q2', 'mood') || answered(a, 'q2', 'sleep')) && (a.q5 === 'some' || a.q5 === 'very');
          },
          why: 'Sensory sensitivity and sleep or mood challenges tend to travel together. Sleep Magnesium is designed to support calm, restful nights, so the whole household gets some relief.'
        },
        {
          when: function (a) { return answered(a, 'q2', 'mood') || answered(a, 'q2', 'sleep'); },
          why: 'Sleep, mood and focus tend to move together, and they all lean on how the night before went. Sleep Magnesium is designed to support calm, restful nights, so the whole household gets some relief.'
        },
        {
          when: function () { return true; },
          why: "You told us they're sensitive to textures, tags or noise. That kind of sensitivity and restless evenings tend to travel together. Sleep Magnesium is designed to support calm, restful nights, so the whole household gets some relief."
        }
      ],
      rowWhy: 'Supports calm, restful nights. No melatonin, no grogginess.'
    },

    /* doc, Section 5. Unreachable: no Kids' Protein SKU exists (GAP 4). */
    Pr: {
      why: "When the list of accepted foods is short, protein is often the first thing to fall short too, and it's foundational to growth. This pairing fills that gap without asking your child to eat anything new.",
      rowWhy: 'Fills the protein gap when the list of accepted foods is short.'
    },

    ironNote: 'You told us iron is a concern, so we have pre-selected the Iron with Vitamin C version below. It pairs bioavailable iron with the vitamin C that helps the body absorb it.',
    iron: {
      rowWhy: 'Bioavailable iron paired with the vitamin C that helps absorb it.'
    },

    /* NOT DOC COPY. NEEDS CLIENT SIGN-OFF. */
    handoff: "You'll go to the {product} page to choose your plan and check out.",
    handoffPlus: "You'll go to the {product} page. Anything you selected above is added with it."
  };

  /* Q1 answer -> base MV key */
  var AGE_TO_BASE = { toddler: 'mv_toddler', kids: 'mv_kids', teen: 'mv_teen' };

  /* Scoring category -> PRODUCTS key. */
  var CATEGORY_PRODUCT = { F: 'fiber', P: 'probiotic', Im: 'immunity', S: 'magnesium', Pr: 'protein' };

  /* Tie-break order, doc Section 4 with Im slotted directly after P. */
  var TIEBREAK = ['F', 'P', 'Im', 'Pr', 'S'];

  var UTM = { utm_source: 'quiz', utm_medium: 'onsite', utm_campaign: 'product-quiz' };

  var DECISIONS = {
    /* GAP 4: Protein has no SKU. "fallthrough" = take the next add-on. */
    proteinMissing: 'fallthrough',
    /* GAP 5: secondary module visible on load. */
    secondaryModule: 'onload'
  };

  var ICON_CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
  var ICON_ARROW = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>';
  var ICON_BACK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>';

  /* True when question `qid` has `val` selected, single string or array. */
  function answered(a, qid, val) {
    var v = a[qid];
    return Array.isArray(v) ? v.indexOf(val) > -1 : v === val;
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  /* Shopify CDN images accept a width param. The source files are up to
     2000px PNGs (1.5 MB+) shown at 48px, so always ask for a sized copy. */
  function sized(url, w) {
    if (!url || !/(cdn\.shopify\.com|\/cdn\/shop\/)/.test(url) || /[?&]width=/.test(url)) return url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function track(name, data) {
    window.dataLayer = window.dataLayer || [];
    var payload = { event: name };
    for (var k in data) if (Object.prototype.hasOwnProperty.call(data, k)) payload[k] = data[k];
    window.dataLayer.push(payload);
  }

  var PRODUCT_KEYS = ['mv_toddler', 'mv_kids', 'mv_teen', 'fiber', 'probiotic', 'magnesium', 'immunity', 'iron'];

  /* Liquid passes one entry per "Quiz product" block, prices in cents. The
     engine works in dollars keyed by slot, as the source HTML did. A slot with
     no block becomes an unavailable placeholder, so routing skips it instead
     of throwing. */
  function normaliseProducts(list) {
    var byKey = {};
    (Array.isArray(list) ? list : []).forEach(function (p) {
      if (p && p.key) byKey[p.key] = p;
    });
    var out = {};
    PRODUCT_KEYS.forEach(function (key) {
      var p = byKey[key] || {};
      out[key] = {
        name: p.name || '',
        age: p.age || '',
        handle: p.handle || '',
        url: p.url || (p.handle ? '/products/' + p.handle : '#'),
        variantId: p.variantId || null,
        price: typeof p.price === 'number' ? p.price / 100 : 0,
        ironVariantId: p.ironVariantId || null,
        ironPrice: typeof p.ironPrice === 'number' ? p.ironPrice / 100 : 0,
        img: p.img || '',
        bullets: String(p.bullets || '')
          .split(/\r?\n/)
          .map(function (b) { return b.trim(); })
          .filter(Boolean),
        available: !!p.available
      };
    });
    /* PROTEIN: scored and written, but NO SKU EXISTS on ellaola.com yet.
       available:false makes routing skip it (GAP 4). */
    out.protein = { name: "Kids' Protein", handle: '', url: '', variantId: null, price: 0, img: '', bullets: [], available: false };
    return out;
  }

  /* ==========================================================================
     ONE QUIZ INSTANCE
     ========================================================================== */
  function initQuiz(root) {
    if (root.dataset.acc05Ready) return;
    root.dataset.acc05Ready = '1';

    var cfgEl = root.querySelector('script[data-acc05-config]');
    var cfg = {};
    try {
      cfg = JSON.parse(cfgEl ? cfgEl.textContent : '{}') || {};
    } catch (e) {
      cfg = {};
    }
    var L = cfg.labels || {};
    var PRODUCTS = normaliseProducts(cfg.products);
    var CONFIG = {
      discountPct: parseInt(cfg.discountPct, 10) || 0,
      autoAdvance: !!cfg.autoAdvance,
      calcDelay: typeof cfg.calcDelay === 'number' ? cfg.calcDelay : 2100,
      qa: !!cfg.qa
    };

    var stage = root.querySelector('[data-acc05-questions]');
    var progressFill = root.querySelector('[data-acc05-progress]');
    var stepMeta = root.querySelector('[data-acc05-step-meta]');
    var resultRoot = root.querySelector('[data-acc05-result]');
    var startBtn = root.querySelector('[data-acc05-start]');
    if (!stage || !resultRoot || !startBtn) return;

    var answers = {};
    var history = [];
    var current = 'intro';
    var selected = { primary: true, secondary: false, iron: true };

    /* Shopify's own formatter (theme assets/global.js) with the store's
       shop.money_format, which follows the visitor's market: "${{amount}}"
       on the US store, "Rs. {{amount}}" for India. Whole amounts drop ".00",
       as the source HTML did: $49 / $39.20. */
    function money(n) {
      var cents = Math.round(n * 100);
      var out = window.Shopify && typeof window.Shopify.formatMoney === 'function'
        ? window.Shopify.formatMoney(cents)
        : '$' + (cents / 100).toFixed(2);
      return out.replace(/[.,]00(?!\d)/, '');
    }
    /* Live promo price. Display only: Shopify applies the real discount.
       Same formula as the PDP (price x 0.8 at 20%). */
    function disc(n) {
      var p = CONFIG.discountPct || 0;
      return p ? Math.round(n * (100 - p)) / 100 : n;
    }
    function priceHtml(n) {
      var d = disc(n);
      return money(d) + (d === n ? '' : ' <s class="acc05-was">' + money(n) + '</s>');
    }

    /* ---------- build the question screens ---------- */
    function buildQuestions() {
      var html = '';
      QUESTIONS.forEach(function (q) {
        var multi = !!q.multi;
        html +=
          '<section class="acc05-screen" data-screen="' + q.id + '"' +
            (multi ? ' data-max="' + q.multi + '"' : '') + '>' +
            '<div class="acc05-qcard">' +
              '<div class="acc05-qcard__step" data-step-label></div>' +
              '<h2 class="acc05-qcard__title">' + esc(q.q) + '</h2>' +
              (q.help ? '<p class="acc05-qcard__help">' + esc(q.help) + '</p>' : '') +
              '<div class="acc05-opts' + (multi ? ' acc05-opts--multi' : '') + '"' +
                ' role="' + (multi ? 'group' : 'radiogroup') + '"' +
                ' aria-label="' + esc(q.q) + '">' +
                q.options.map(function (o) {
                  return '<label class="acc05-opt">' +
                    '<input type="' + (multi ? 'checkbox' : 'radio') + '"' +
                      ' name="acc05-' + q.id + '" value="' + o.id + '" autocomplete="off">' +
                    '<span class="acc05-opt__dot" aria-hidden="true">' + (multi ? ICON_CHECK : '') + '</span>' +
                    '<span class="acc05-opt__label">' + esc(o.label) + '</span>' +
                    (o.sub ? '<span class="acc05-opt__sub">' + esc(o.sub) + '</span>' : '') +
                  '</label>';
                }).join('') +
              '</div>' +
              '<div class="acc05-qnav">' +
                '<button type="button" class="acc05-back" data-back>' + ICON_BACK + ' ' + esc(L.back || 'Back') + '</button>' +
                '<button type="button" class="acc05-btn" data-next disabled>' + esc(L.next || 'Next') + ' ' + ICON_ARROW + '</button>' +
              '</div>' +
            '</div>' +
          '</section>';
      });
      stage.innerHTML = html;
    }

    function activeQuestions() {
      return QUESTIONS.filter(function (q) {
        return typeof q.showIf !== 'function' || q.showIf(answers);
      });
    }

    function showScreen(key, pushHistory) {
      if (pushHistory !== false && current && current !== key) history.push(current);
      current = key;

      var all = root.querySelectorAll('.acc05-screen');
      for (var i = 0; i < all.length; i++) all[i].classList.remove('acc05-is-active');
      var el = root.querySelector('.acc05-screen[data-screen="' + key + '"]');
      if (el) el.classList.add('acc05-is-active');

      var phase = key === 'intro' || key === 'calc' || key === 'result' ? key : 'question';
      root.setAttribute('data-phase', phase);

      updateChrome();
      var top = root.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({ top: Math.max(0, top), behavior: history.length > 1 ? 'smooth' : 'auto' });

      /* Focus the card heading so screen readers announce the new question. */
      if (el && phase === 'question') {
        syncScreen(el);
        var h = el.querySelector('h2');
        if (h) {
          h.setAttribute('tabindex', '-1');
          h.focus({ preventScroll: true });
        }
      }
    }

    function updateChrome() {
      var live = activeQuestions();
      var idx = live.findIndex(function (q) { return q.id === current; });

      if (idx > -1) {
        var n = idx + 1;
        var total = live.length;
        var label = (L.step || 'Question {n} of {total}').replace('{n}', n).replace('{total}', total);
        if (stepMeta) stepMeta.textContent = label;
        if (progressFill) progressFill.style.width = ((n - 1) / total) * 100 + (100 / total) * 0.35 + '%';
        var lbl = root.querySelector('.acc05-screen[data-screen="' + current + '"] [data-step-label]');
        if (lbl) lbl.textContent = label;
        var back = root.querySelector('.acc05-screen[data-screen="' + current + '"] [data-back]');
        if (back) back.hidden = history.length === 0;
      } else if (current === 'result' || current === 'calc') {
        if (stepMeta) stepMeta.textContent = current === 'result' ? L.resultEyebrow || 'Your match' : '';
        if (progressFill) progressFill.style.width = '100%';
      } else {
        if (stepMeta) stepMeta.textContent = '';
        if (progressFill) progressFill.style.width = '0%';
      }
    }

    /* ---------- next / back ---------- */
    function nextFrom(id) {
      var live = activeQuestions();
      var idx = live.findIndex(function (q) { return q.id === id; });
      if (idx > -1) return idx < live.length - 1 ? live[idx + 1].id : 'calc';

      var order = QUESTIONS.findIndex(function (q) { return q.id === id; });
      for (var i = 0; i < live.length; i++) {
        if (QUESTIONS.indexOf(live[i]) > order) return live[i].id;
      }
      return 'calc';
    }

    function goNext() {
      var target = nextFrom(current);
      if (target === 'calc') {
        runCalc();
        return;
      }
      showScreen(target);
    }

    function goBack() {
      var prev = history.pop();
      if (!prev) return;
      showScreen(prev, false);
    }

    /* ---------- calculating screen, then result ---------- */
    var calcTick = null;
    var calcTimer = null;
    function runCalc() {
      track('quiz_complete', {
        quiz_answers: JSON.stringify(answers),
        quiz_answer_count: Object.keys(answers).length
      });

      if (!CONFIG.calcDelay) {
        renderResult();
        showScreen('result');
        return;
      }

      showScreen('calc');
      var items = root.querySelectorAll('[data-acc05-calc-steps] li');
      for (var i = 0; i < items.length; i++) items[i].classList.remove('acc05-is-on');
      var step = 0;
      clearInterval(calcTick);
      clearTimeout(calcTimer);
      calcTick = setInterval(function () {
        if (items[step]) items[step].classList.add('acc05-is-on');
        step++;
        if (step >= items.length) clearInterval(calcTick);
      }, CONFIG.calcDelay / (items.length + 1));

      calcTimer = setTimeout(function () {
        renderResult();
        showScreen('result', false);
      }, CONFIG.calcDelay);
    }

    /* ==========================================================================
       SCORING  (logic doc, Section 3)
       ========================================================================== */
    function scoreAnswers() {
      var s = { F: 0, P: 0, S: 0, Pr: 0, I: 0, Im: 0 };
      QUESTIONS.forEach(function (q) {
        var picked = answers[q.id];
        if (!picked) return;
        var chosen = Array.isArray(picked) ? picked : [picked];
        chosen.forEach(function (id) {
          var opt = null;
          for (var i = 0; i < q.options.length; i++) {
            if (q.options[i].id === id) {
              opt = q.options[i];
              break;
            }
          }
          if (!opt || !opt.points) return;
          for (var k in opt.points) {
            if (Object.prototype.hasOwnProperty.call(opt.points, k)) s[k] += opt.points[k];
          }
        });
      });
      return s;
    }

    /* ==========================================================================
       ROUTING  (logic doc, Section 4)
         1. Base SKU by age
         2. Iron swap if I >= 3  (variant swap, does not consume the add-on slot)
         3. Primary add-on = highest of F, P, Im, Pr, S by TIEBREAK
         4. No signal -> base alone
         5. Secondary = next highest scoring >= 1
       ========================================================================== */
    function route() {
      var s = scoreAnswers();

      var baseKey = AGE_TO_BASE[answers.q1] || 'mv_kids';
      var base = PRODUCTS[baseKey];

      var ironSignal = s.I >= 3;
      var ironSwap = ironSignal && !!base.ironVariantId;

      var ranked = TIEBREAK.slice().sort(function (a, b) {
        return s[b] - s[a] || TIEBREAK.indexOf(a) - TIEBREAK.indexOf(b);
      });
      var scoring = ranked.filter(function (k) { return s[k] > 0; });
      var available = scoring.filter(function (k) {
        var p = PRODUCTS[CATEGORY_PRODUCT[k]];
        return p && p.available && p.variantId;
      });
      var suppressed = scoring.length && scoring[0] !== available[0] ? scoring[0] : null;

      var primary = null;
      var secondary = null;
      if (suppressed && DECISIONS.proteinMissing === 'base_only') {
        /* Client chose: do not substitute, show the base MV alone. */
      } else {
        primary = available[0] || null;
        for (var i = 1; i < available.length; i++) {
          if (s[available[i]] >= 1) {
            secondary = available[i];
            break;
          }
        }
      }

      return {
        scores: s,
        baseKey: baseKey,
        base: base,
        ironSignal: ironSignal,
        ironSwap: ironSwap,
        primary: primary,
        secondary: secondary,
        suppressed: suppressed,
        noSignal: primary === null
      };
    }

    /* ==========================================================================
       LINK BUILDERS
       ========================================================================== */
    function params(extra) {
      var p = [];
      for (var k in UTM) if (Object.prototype.hasOwnProperty.call(UTM, k)) {
        p.push(k + '=' + encodeURIComponent(UTM[k]));
      }
      for (var j in extra) if (Object.prototype.hasOwnProperty.call(extra, j) && extra[j] != null && extra[j] !== '') {
        p.push(j + '=' + encodeURIComponent(extra[j]));
      }
      return p.join('&');
    }

    function baseItem(r) {
      return { key: 'base', label: r.base.name, variantId: r.base.variantId, price: r.base.price };
    }

    function addonItems(r) {
      var items = [];
      if (r.primary && selected.primary) {
        var p = PRODUCTS[CATEGORY_PRODUCT[r.primary]];
        items.push({ key: 'primary', label: p.name, variantId: p.variantId, price: p.price });
      }
      if (r.secondary && selected.secondary) {
        var q = PRODUCTS[CATEGORY_PRODUCT[r.secondary]];
        items.push({ key: 'secondary', label: q.name, variantId: q.variantId, price: q.price });
      }
      return items;
    }

    function ironOn(r) {
      return !!(r.ironSwap && selected.iron);
    }

    function ctaVariantId(r) {
      return ironOn(r) ? r.base.ironVariantId : r.base.variantId;
    }

    function ironDelta(r) {
      return disc(r.base.ironPrice) - disc(r.base.price);
    }

    /* ==========================================================================
       PDP HANDOFF  -  the quiz's only exit.
       PARAMETER CONTRACT (read on the PDP by the ACC_EllaOla_LP_05 conversion.io campaign)
         variant         base variant id; the "+ Iron" bundle while the iron row is ticked
         quiz            always "1"
         quiz_addons     ticked recommendations as "variantId:qty", comma separated
         quiz_age        toddler | kids | teen
         quiz_primary    scoring category of the primary rec
         quiz_secondary  scoring category of the soft rec, ticked or not
         quiz_iron       "1" while the iron row is ticked
       ========================================================================== */
    function pdpUrl(r) {
      var extra = {
        variant: ctaVariantId(r),
        quiz: '1',
        quiz_addons: addonItems(r).map(function (i) { return i.variantId + ':1'; }).join(','),
        quiz_age: answers.q1,
        quiz_primary: r.primary || '',
        quiz_secondary: r.secondary || '',
        quiz_iron: ironOn(r) ? '1' : ''
      };
      return r.base.url + '?' + params(extra);
    }

    /* ==========================================================================
       RESULT RENDER
       ========================================================================== */
    function fill(str, r) {
      var ageLabel = { mv_toddler: "Toddlers'", mv_kids: "Kids'", mv_teen: "Teens'" }[r.baseKey] || '';
      return str.replace(/\{name\}/g, 'your child').replace(/\{age\}/g, esc(ageLabel));
    }

    function whyFor(copy) {
      if (copy.variants) {
        for (var i = 0; i < copy.variants.length; i++) {
          if (copy.variants[i].when(answers)) return copy.variants[i].why;
        }
      }
      return copy.why || '';
    }

    function headCopy(r) {
      var key = r.primary ? r.primary : 'base';
      var copy = RESULT_COPY[key] || RESULT_COPY.base;
      var why = fill(whyFor(copy), r);
      if (r.ironSignal) why = fill(RESULT_COPY.ironNote, r) + ' ' + why;
      return { headline: fill(RESULT_COPY.base.headline, r), why: why };
    }

    function renderResult() {
      var r = route();

      var softCat = r.secondary;
      var softP = softCat ? PRODUCTS[CATEGORY_PRODUCT[softCat]] : null;
      if (!softP || !softP.available || !softP.variantId || DECISIONS.secondaryModule !== 'onload') {
        softCat = null;
        softP = null;
      }
      r.secondary = softCat;

      /* Recommendations are PRE-SELECTED, per the client. */
      selected.primary = !!r.primary;
      selected.secondary = !!softP;
      selected.iron = !!r.ironSwap;

      var head = headCopy(r);
      var base = baseItem(r);
      var html = '';

      html +=
        '<div class="acc05-result__head">' +
          '<span class="acc05-eyebrow">' + esc(L.resultEyebrow || 'Your match') + '</span>' +
          '<h2 class="acc05-result__title" tabindex="-1">' + head.headline + '</h2>' +
        '</div>';

      html += '<div class="acc05-match">';

      /* 1. the product */
      html +=
        '<div class="acc05-match__sec">' +
          '<div class="acc05-match__product">' +
            '<div class="acc05-match__media">' +
              (r.base.img ? '<img src="' + esc(sized(r.base.img, 600)) + '" alt="' + esc(r.base.name) + '" loading="lazy" width="600" height="600">' : '') +
            '</div>' +
            '<div>' +
              '<h3 class="acc05-match__name">' + esc(base.label) + '</h3>' +
              '<div class="acc05-match__age">' + esc(r.base.age) + '</div>' +
              '<div class="acc05-match__price">' +
                '<span class="acc05-price">' + priceHtml(base.price) + '</span>' +
                (CONFIG.discountPct ? '<span class="acc05-save-badge">' + esc((L.save || 'Save {pct}%').replace('{pct}', CONFIG.discountPct)) + '</span>' : '') +
              '</div>' +
              (L.unit ? '<span class="acc05-match__unit">' + esc(L.unit) + '</span>' : '') +
              '<ul class="acc05-bullets">' +
                r.base.bullets.map(function (b) {
                  return '<li>' + ICON_CHECK + '<span>' + esc(b) + '</span></li>';
                }).join('') +
              '</ul>' +
            '</div>' +
          '</div>' +
        '</div>';

      /* 2. why this match */
      html +=
        '<div class="acc05-match__sec">' +
          '<div class="acc05-match__label">' + esc(L.basedOn || 'Based on your answers') + '</div>' +
          '<p class="acc05-match__why">' + head.why + '</p>' +
        '</div>';

      /* 3. add-ons */
      if (r.primary || softP || r.ironSwap) {
        html +=
          '<div class="acc05-match__sec">' +
            '<div class="acc05-match__label">' + esc(L.routine || 'Complete their routine') + '</div>' +
            '<p class="acc05-match__hint">' + esc(L.hint || "Untick anything you don't want.") + '</p>';

        if (r.ironSwap) {
          html += pickCard({
            state: 'iron',
            product: PRODUCTS.iron,
            flag: L.flagPrimary || 'Recommended for you',
            name: L.ironName || 'Add Iron with Vitamin C',
            why: L.ironWhy || 'Switches your multivitamin to the version with iron built in. Still one stickpack a day.',
            priceText: '+' + money(ironDelta(r)),
            checked: selected.iron
          });
        }
        if (r.primary) {
          html += pickCard({
            state: 'primary',
            product: PRODUCTS[CATEGORY_PRODUCT[r.primary]],
            flag: L.flagPrimary || 'Recommended for you',
            checked: selected.primary,
            why: (RESULT_COPY[r.primary] || {}).rowWhy || ''
          });
        }
        if (softP) {
          html += pickCard({
            state: 'secondary',
            product: softP,
            flag: L.flagSecondary || 'Parents like you also added',
            why: (RESULT_COPY[softCat] || {}).rowWhy || '',
            soft: true,
            checked: selected.secondary
          });
        }
        html += '</div>';
      }

      /* 4. one action */
      html +=
          '<div class="acc05-match__sec">' +
            '<div class="acc05-match__cta">' +
              '<a class="acc05-btn acc05-btn--lg" data-cta href="#">' + esc(L.cta || 'See your match') + ' ' + ICON_ARROW + '</a>' +
            '</div>' +
            '<span class="acc05-match__note" data-acc05-sum></span>' +
          '</div>' +
        '</div>' +
        '<div class="acc05-restart">' +
          '<button class="acc05-textlink" type="button" data-acc05-restart>' + esc(L.restart || 'Retake the quiz') + '</button>' +
        '</div>';

      resultRoot.innerHTML = html;
      wireResult(r);
      updateSummary(r);

      track('quiz_result_view', {
        quiz_base: r.baseKey,
        quiz_addon: r.primary || 'none',
        quiz_addon2: r.secondary || 'none',
        quiz_iron_offered: r.ironSwap ? 1 : 0,
        quiz_suppressed: r.suppressed || 'none',
        quiz_scores: JSON.stringify(r.scores)
      });
    }

    function pickCard(o) {
      var p = o.product;
      if (!p || !p.available || !p.variantId) return '';
      var on = !!o.checked;
      var name = o.name || p.name;
      return '<label class="acc05-pick' + (o.soft ? ' acc05-pick--soft' : '') + (on ? ' acc05-is-checked' : '') + '" data-addon="' + o.state + '">' +
        '<input type="checkbox"' + (on ? ' checked' : '') + '>' +
        '<span class="acc05-pick__box" aria-hidden="true">' + ICON_CHECK + '</span>' +
        '<span class="acc05-pick__media">' + (p.img ? '<img src="' + esc(sized(p.img, 96)) + '" alt="' + esc(p.name) + '" loading="lazy" width="96" height="96">' : '') + '</span>' +
        '<span class="acc05-pick__text">' +
          (o.flag ? '<span class="acc05-pick__flag">' + esc(o.flag) + '</span>' : '') +
          '<span class="acc05-pick__name">' + esc(name) + '</span>' +
          (o.why ? '<span class="acc05-pick__why">' + esc(o.why) + '</span>' : '') +
        '</span>' +
        '<span class="acc05-pick__price">' + (o.priceText || priceHtml(p.price)) + '</span>' +
      '</label>';
    }

    function wireResult(r) {
      var rows = resultRoot.querySelectorAll('.acc05-pick');
      for (var i = 0; i < rows.length; i++) {
        (function (row) {
          var input = row.querySelector('input');
          input.addEventListener('change', function () {
            row.classList.toggle('acc05-is-checked', input.checked);
            selected[row.getAttribute('data-addon')] = input.checked;
            updateSummary(r);
            track('quiz_addon_toggle', {
              quiz_addon_slot: row.getAttribute('data-addon'),
              quiz_addon_checked: input.checked ? 1 : 0
            });
          });
        })(rows[i]);
      }

      var ctas = resultRoot.querySelectorAll('[data-cta]');
      for (var c = 0; c < ctas.length; c++) {
        ctas[c].addEventListener('click', function () {
          var addons = addonItems(r);
          track('quiz_pdp_handoff', {
            quiz_base_variant: ctaVariantId(r),
            quiz_base_handle: r.base.handle,
            quiz_iron_swap: ironOn(r) ? 1 : 0,
            quiz_addons: addons.map(function (i) { return i.variantId; }).join(',') || 'none',
            quiz_addon_count: addons.length
          });
        });
      }

      var restartBtn = resultRoot.querySelector('[data-acc05-restart]');
      if (restartBtn) restartBtn.addEventListener('click', restart);
    }

    /* Keeps the CTA target and the handoff line in step with what is ticked.
       The CTA LABEL never changes, so it does not shift under the finger. */
    function updateSummary(r) {
      var addons = addonItems(r);
      var base = baseItem(r);
      var url = pdpUrl(r);

      var ctas = resultRoot.querySelectorAll('[data-cta]');
      for (var i = 0; i < ctas.length; i++) ctas[i].setAttribute('href', url);

      var line = resultRoot.querySelector('[data-acc05-sum]');
      if (!line) return;

      var product = base.label + (ironOn(r) ? ' + Iron with Vitamin C' : '');
      var text = fill(addons.length ? RESULT_COPY.handoffPlus : RESULT_COPY.handoff, r).replace(/\{product\}/g, product);
      if (addons.length) {
        text += ' Carrying over: ' + addons.map(function (i) { return i.label; }).join(' and ') + '.';
      }
      line.textContent = text;
    }

    /* ==========================================================================
       WIRING
       ========================================================================== */
    function wireQuestions() {
      stage.addEventListener('change', function (e) {
        var input = e.target;
        if (input.type !== 'radio' && input.type !== 'checkbox') return;

        var screen = input.closest('.acc05-screen');
        var qid = screen.getAttribute('data-screen');
        var max = parseInt(screen.getAttribute('data-max'), 10) || 0;

        /* Multi-select. Refuse the selection that would exceed the cap rather
           than silently dropping an earlier one. */
        if (max && input.checked && screen.querySelectorAll('.acc05-opts input:checked').length > max) {
          input.checked = false;
        }
        syncScreen(screen);

        if (qid === 'q1') {
          pruneStaleAnswers();
          updateChrome();
        }

        track('quiz_question_answered', {
          quiz_question: qid,
          quiz_answer: [].concat(answers[qid]).join(',')
        });

        if (CONFIG.autoAdvance && !max) setTimeout(goNext, 320);
      });

      stage.addEventListener('click', function (e) {
        var next = e.target.closest('[data-next]');
        if (next) {
          goNext();
          return;
        }
        var back = e.target.closest('[data-back]');
        if (back) goBack();
      });
    }

    /* Reads what is actually ticked on a question screen and rebuilds the
       answer, the selected / locked states and the Next button from it. The
       DOM is the single source of truth, so a browser that restores ticks
       after a refresh or Back can never leave Next disabled under a ticked
       answer. */
    function syncScreen(screen) {
      var qid = screen.getAttribute('data-screen');
      var max = parseInt(screen.getAttribute('data-max'), 10) || 0;
      var labels = screen.querySelectorAll('.acc05-opt');
      var picked = [];
      var i;
      for (i = 0; i < labels.length; i++) {
        var box = labels[i].querySelector('input');
        if (box.checked && (!max || picked.length < max)) picked.push(box.value);
        else box.checked = false;
      }

      if (max) answers[qid] = picked;
      else if (picked.length) answers[qid] = picked[0];
      else delete answers[qid];

      var atMax = max && picked.length >= max;
      for (i = 0; i < labels.length; i++) {
        var input = labels[i].querySelector('input');
        labels[i].classList.toggle('acc05-is-checked', input.checked);
        labels[i].classList.toggle('acc05-is-locked', !!(atMax && !input.checked));
        /* inert for keyboard users too, not only for the pointer */
        input.disabled = !!(atMax && !input.checked);
      }
      var next = screen.querySelector('[data-next]');
      if (next) next.disabled = picked.length === 0;
    }

    /* Unticks every answer and resets every question screen. */
    function clearInputs() {
      var inputs = stage.querySelectorAll('input');
      for (var i = 0; i < inputs.length; i++) {
        inputs[i].checked = false;
        inputs[i].disabled = false;
      }
      var opts = stage.querySelectorAll('.acc05-opt');
      for (var j = 0; j < opts.length; j++) {
        opts[j].classList.remove('acc05-is-checked');
        opts[j].classList.remove('acc05-is-locked');
      }
      var nexts = stage.querySelectorAll('[data-next]');
      for (var k = 0; k < nexts.length; k++) nexts[k].disabled = true;
    }

    function pruneStaleAnswers() {
      QUESTIONS.forEach(function (q) {
        if (typeof q.showIf === 'function' && !q.showIf(answers)) delete answers[q.id];
      });
    }

    function restart() {
      answers = {};
      history = [];
      clearInputs();
      showScreen('intro', false);
      track('quiz_restart', {});
    }

    /* ==========================================================================
       QA PREVIEW  -  ?preview=result&age=kids&addon=F&addon2=P&iron=1
                      ?preview=q3
       Only active when the section's "QA shortcuts" setting is on, so normal
       visitors are never affected (PRD).
       ========================================================================== */
    function applyPreview() {
      if (!CONFIG.qa) return false;
      var u = new URLSearchParams(window.location.search);
      var p = u.get('preview');
      if (!p) return false;

      if (p === 'result') {
        answers.q1 = u.get('age') || 'kids';
        var addonSeed = { F: 'digestion', P: 'sick', S: 'sleep' };
        answers.q2 = [addonSeed[u.get('addon')] || 'digestion'];
        if (u.get('iron') === '1') answers.q2.push('iron');
        answers.q3 = 'safe';
        answers.q4 = u.get('addon2') === 'F' || u.get('addon') === 'F' ? 'often' : 'sometimes';
        answers.q5 = u.get('addon2') === 'S' || u.get('addon') === 'S' ? 'very' : 'no';

        renderResult();
        showScreen('result', false);
        return true;
      }

      if (/^q/.test(p) && root.querySelector('.acc05-screen[data-screen="' + p + '"]')) {
        answers.q1 = u.get('age') || 'kids';
        showScreen(p, false);
        return true;
      }
      return false;
    }

    /* ==========================================================================
       INIT
       ========================================================================== */
    buildQuestions();
    wireQuestions();

    startBtn.addEventListener('click', function () {
      track('quiz_start', {});
      showScreen(activeQuestions()[0].id);
    });

    /* A refresh or a Back that reloads the page starts the quiz fresh. Some
       browsers restore ticks late, so clear again on pageshow. A page restored
       whole from the back/forward cache (persisted) keeps its live state. */
    clearInputs();
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted && current === 'intro') clearInputs();
    });

    if (!applyPreview()) {
      current = 'intro';
      var introEl = root.querySelector('.acc05-screen[data-screen="intro"]');
      if (introEl) introEl.classList.add('acc05-is-active');
      root.setAttribute('data-phase', 'intro');
      updateChrome();
    }

    /* QA HOOK  -  ?debug=1, only with the QA shortcuts setting on. */
    if (CONFIG.qa && new URLSearchParams(window.location.search).get('debug') === '1') {
      window.quizQA = {
        questions: function () {
          var map = {};
          QUESTIONS.forEach(function (q) {
            map[q.id] = q.options.map(function (o) { return o.id; });
          });
          return map;
        },
        route: function (a) {
          var keep = answers;
          answers = a || {};
          try {
            return route();
          } finally {
            answers = keep;
          }
        },
        copy: function (a) {
          var keep = answers;
          answers = a || {};
          try {
            return headCopy(route());
          } finally {
            answers = keep;
          }
        }
      };
    }

    /* Enter key advances when an answer is selected. */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' || !root.isConnected) return;
      var screen = root.querySelector('.acc05-screen.acc05-is-active');
      if (!screen) return;
      var next = screen.querySelector('[data-next]');
      if (next && !next.disabled && document.activeElement.tagName !== 'BUTTON') {
        e.preventDefault();
        goNext();
      }
    });
  }

  function init(scope) {
    var roots = (scope || document).querySelectorAll('[data-acc05-quiz]');
    for (var i = 0; i < roots.length; i++) initQuiz(roots[i]);
  }

  init(document);

  if (!window.AccEllaolaLp05QuizBound) {
    window.AccEllaolaLp05QuizBound = true;
    document.addEventListener('shopify:section:load', function (e) {
      init(e.target);
    });
  }
})();
